import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ProcessDefinitionService} from "../../services/definitions.service";
import {TaskService} from "../../services/task.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  standalone: false,
  selector: 'alg-form-processus-dialog',
  templateUrl: './form-processus-dialog.component.html',
  styleUrls: ['../../ui/workflow-dialog.scss', './form-processus-dialog.component.scss'],
})
export class FormProcessusDialogComponent implements OnInit {
  processDefinitions: any;
  processDefinition: any;
  formProperties: any[];
  propertiesInForm = [
    "bpm:workflowDueDate",
    "bpm:workflowDescription",
    "bpm:workflowPriority",
    "bpm:sendEMailNotifications",
    "bpm:status",
    "bpm:comment"
  ];
  form: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) public data,
              public dialogRef: MatDialogRef<FormProcessusDialogComponent>,
              private processusDefinitionsService: ProcessDefinitionService,
              private fb: FormBuilder,
              private taskService: TaskService) {
  }

  ngOnInit(): void {
    this.processusDefinitionsService.getProcessDefinitions().subscribe((data: any) => {
      this.processDefinitions = data.list.entries.filter(element => element.entry.startFormResourceKey?.startsWith('rc'));
    });
  }

  processSelected($event: any) {
    let fieldToSupress = ["bpm:workflowDueDate", 'bpm:workflowDescription', 'bpm:workflowPriority', 'bpm:status'];
    this.taskService.getProperties($event?.startFormResourceKey)?.subscribe((data: any) => {
      data.entry.properties = data.entry.properties.filter(element => element.isProtected !== true);
      this.formProperties = [...data.entry.properties.filter(element => this.propertiesInForm.includes(element.id)), ...data.entry.associations.filter(element => element.id.startsWith('rc')), ...data.entry.properties.filter(element => element.id.startsWith('rc'))]
      this.formProperties = this.formProperties.filter(element => !fieldToSupress.includes(element.id));
      this.form = this.createForm();
      this.setDefaultValues();
    });
  }

  createForm() {
    const formGroup = this.fb.group({});
    this.formProperties.forEach((prop) => {
      if (prop.title) {
        const validator = this.getValidator(prop);
        formGroup.addControl(prop.id, this.fb.control(prop.value ?? (this.isMultiValued(prop) ? [] : null), validator));
      }

    });
    return formGroup;
  }

  setDefaultValues() {
    this.formProperties.forEach((prop) => {
      if (prop.title) {
        if (prop.id === 'bpm:sendEMailNotifications') {
          this.form.get(prop.id).setValue(true);
        }
      }
    });
  }

  getValidator(prop) {
    const validators = [];
    if (prop.mandatory) {
      validators.push(Validators.required);
    }

    if (prop.constraints) {
      prop.constraints.forEach((constraint) => {
        switch (constraint.type) {
          case 'LENGTH':
            validators.push(Validators.minLength(constraint.parameters?.minLength));
            validators.push(Validators.maxLength(constraint.parameters?.maxLength));
            break;
        }
      });
    }

    return validators;
  }

  private isMultiValued(prop: any): boolean {
    return prop?.isMultiValued === true || prop?.multiValued === true || prop?.target?.isMany === true;
  }
}
